module.exports = __webpack_public_path__ + "img/marleen-finsterle.fddcc165.jpg";